// extracted by mini-css-extract-plugin
export var circleButton = "button-module--circle-button--syQp9";
export var content = "button-module--content--MRtQl";
export var largeButton = "button-module--large-button--MAjKj";
export var shared = "button-module--shared--e4xzj";
export var smallButton = "button-module--small-button--a1aoz";
export var textButton = "button-module--text-button--xMZ4w";